export type InterfaceTheme = 'light' | 'dark';
export const THEME_KEY = 'overland-traces.studio-interface-theme.v1';

export function readInterfaceTheme(storage: Pick<Storage, 'getItem'>): InterfaceTheme {
  try { return storage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'; }
  catch { return 'light'; }
}

export function saveInterfaceTheme(storage: Pick<Storage, 'setItem'>, theme: InterfaceTheme) {
  try { storage.setItem(THEME_KEY, theme); } catch { /* The current session still supports theme selection. */ }
}
